module.exports = __webpack_public_path__ + "@/assets/img/firmNewPP.a6855946.png";